module.exports = __webpack_public_path__ + "static/media/texture.3b67497a.svg";